import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`

export const SectionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  padding: 20px 0 5px 0;
`

export const SectionDot = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`

export const HelpIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #111827;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  cursor: default;
  flex-shrink: 0;
`

export const Card = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
`

export const CardSubtitle = styled.div`
  font-size: 16px;
  line-height: 21px;
  color: #111827;
  font-weight: 500;
`

export const TwoColumnRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`

// ---- Threat impact table ----

export const ImpactHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 12px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  font-size: 14px;
  color: #111827;
`

export const InlineLegend = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`

export const InlineLegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

export const InlineLegendDot = styled.span`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`

export const ThreatRow = styled.div`
  display: flex;
  align-items: center;
  padding: 16.5px 15px;
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
  }
`

export const ThreatRowLabel = styled.div`
  font-size: 16px;
  line-height: 21px;
  font-weight: 500;
  color: #111827;
  width: 300px;
  flex-shrink: 0;
`

export const ThreatRowBar = styled.div`
  flex: 1;
  min-width: 0;
`

export const ResponseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`
